import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { DocumentHistory, FileHistory } from '../../document.interface';
import { AppFilesService } from 'src/app/services/app-files.service';
import { FormControl, FormGroup } from '@angular/forms';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-istoric',
    templateUrl: './istoric.component.html',
    styleUrls: ['./istoric.component.scss'],
})
export class IstoricComponent implements OnInit {
    @Input() historyData!: DocumentHistory[];
    @Input() id_document!: number;
    @Input() currentUser!: any;
    @Output() isLoading = new EventEmitter<boolean>();

    helper = helper;
    isLoadingOperator = false;
    isLoadingCitizen = false;
    isLoadingAll = false;

    searchParamsForm!: FormGroup;
    filteredHistory: DocumentHistory[] = [];
    initialFormValue = {
        defaultValue: -1,
    };
    messageFilters = [
        { key: '--Toate--', filters: -1 },
        { key: 'Către cetățean', filters: { automated: 0, type: [0, 1] } },
        { key: 'Altă destinație', filters: { automated: 0, type: [4] } },
        { key: 'Intern', filters: { automated: 0, type: [2, 3] } },
        { key: 'Automat', filters: { automated: 1, type: [] } },
    ];

    initFilterForm() {
        this.searchParamsForm = new FormGroup({
            messageFilter: new FormControl(this.initialFormValue.defaultValue),
        });
    }

    constructor(
        private dashboardService: DashboardService,
        private appFilesService: AppFilesService
    ) { }

    ngOnInit(): void {
        this.initFilterForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.filterHistoryByType();
    }

    filterHistoryByType() {
        const selectedFilter = this.searchParamsForm?.get('messageFilter')?.value || -1;

        if (selectedFilter === -1) {
            this.filteredHistory = this.historyData;
        } else if (selectedFilter.automated) {
            this.filteredHistory = this.historyData.filter(entry => entry.automated);
        } else {
            this.filteredHistory = this.historyData.filter(entry => selectedFilter.type.includes(entry.type));
        }
    }

    downloadDocumentFile(file: FileHistory) {
        this.isLoading.emit(true);
        const fullPath = this.dashboardService.documentDownloadFileUrl + file.id;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading.emit(false);
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading.emit(false);
            })
    }

    /*
        Pentru type-uri:
        1: Conv de operator + nota interna
        2: Conv de la cetatean
        3: Conv all
    */

    exportConv(type: number) {
        // Set the appropriate loading flag to true based on the type
        if (type === 1) this.isLoadingOperator = true;
        if (type === 2) this.isLoadingCitizen = true;
        if (type === 3) this.isLoadingAll = true;

        this.dashboardService.exportHistory(this.id_document, type).subscribe({
            next: (data: Blob) => {
                const blobUrl = URL.createObjectURL(data);
                window.open(blobUrl, '_blank');
                this.resetLoadingFlags();
            },
            error: (error) => {
                console.error('Error exporting PDF:', error);
                this.resetLoadingFlags();
            }
        });
    }

    resetLoadingFlags() {
        this.isLoadingOperator = false;
        this.isLoadingCitizen = false;
        this.isLoadingAll = false;
    }
}
